import React, { useState } from 'react';
import StudentTemplate from '../../component/StudentTemplate';
import { ToastContainer, toast } from 'react-toastify';
import { useEffect, useRef, useMemo } from 'react';
import Api from '../../component/Api';
import Select from 'react-select';
import { useNavigate } from 'react-router-dom';
import useAuth from '../../component/useAuth.js';
import Loader from '../../component/Loader.js';
import { Info } from '@mui/icons-material';


const ExamReg = () => {
    const navigate = useNavigate();
    const isAuth = useAuth();

    if (isAuth === false) {
        navigate("/")
    }

    const { http } = Api();

    const [examid, setExamIdData] = useState('');

    const [getexamData, setExamData] = useState([]);

    const [semesterid, setsemesterid] = useState('');

    const [studentData, setStudentData] = useState([]);

    const [Regtype, setRegtypeData] = useState("R");

    const [Kpcr, setKpcr] = useState(0);

    const [StudentFee, setStudentFeeData] = useState([]);

    const [isDownloading, setIsDownloading] = useState(false)

    const [Kpcr_result, setKpcr_result] = useState(false)


    const handlExamChange = (selectedOption) => {

        setExamIdData(selectedOption.value);
        setsemesterid(selectedOption.semesterid);
    };

    useEffect(() => {
        const fetchExamData = async () => {
            try {
                const response = await http.get(`/Student/getAtiveExam`);

                // console.log("response", response.data);
                setExamData(response.data);

            }
            catch (error) {
                if (error.response.data.http_status === 401 && error.response.data.status_code == "ERR9") {
                    toast.error("Invalid Token");
                    setTimeout(() => {
                        navigate("/");
                    }, 5000);

                }
                else if (error.response.data.http_status === 429 && error.response.data.status_code == "ERR33") {
                    toast.error(error.response.data.message);
                }
                else if (error.response.data.http_status === 500 && error.response.data.status_code == "ERR5") {
                    toast.error("No active exam found");
                }
                else {
                    toast.error("Something went wrong");
                }
            }
        };

        fetchExamData();
    }, []);


    useEffect(() => {
        const fetchFeeData = async () => {
            try {


                const StudentExamDetails = await http.get(`/Student/getStudentfeedetails`,
                    {
                        params: {
                            exam_id: examid,
                            semester_id: semesterid,
                            Regtype: Regtype,
                            is_kpcr: Kpcr
                        }
                    }
                )
                if (!Kpcr) {

                    setStudentData(StudentExamDetails.data.paper_wise_fee);
                    setStudentFeeData(StudentExamDetails.data.sem_wise_fee);
                }
                else {

                    // setStudentData([]);
                    // setStudentFeeData([]);

                    if (StudentExamDetails.data.fee_con_type == "KPCR") {

                        setStudentData(StudentExamDetails.data.paper_wise_fee);
                        setStudentFeeData(StudentExamDetails.data.sem_wise_fee);

                        toast.success('You are eligible for KPCR concession of Rs.' + StudentExamDetails.data.sem_wise_fee)
                    }
                    else {

                    
                        toast.error('You are not eligible for KPCR concession')

                    }

                }

            }

            catch (error) {

                console.log("error", error);
                toast.error("Something went wrong");


            }
        };

        if (semesterid && examid) {

            fetchFeeData();
        }

    }, [semesterid, examid, Regtype, Kpcr]);

    const handleGeneratePDFNew = async () => {

        setIsDownloading(true)

        try {
            const response = await http.get('/generateApplicationFormPdf', {
                params: {
                    examid: examid,
                },
                responseType: 'blob',

            });

            if (response && response.data) {

                const url = window.URL.createObjectURL(new Blob([response.data]));
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', `${localStorage.getItem('user')}-Exam-Registration.pdf`);
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
                setIsDownloading(false);
                return Promise.resolve('PDF generated successfully ');

            }

        } catch (error) {
            console.log("error", error);

            if (error.response?.data instanceof Blob) {
                // Parse blob into JSON
                error.response.data.text().then(text => {
                    try {
                        const json = JSON.parse(text);

                        if (json.status_code === "ERR66") {
                            toast.error(json.message);
                        } else {
                            toast.error("Something went wrong");
                        }
                    } catch (e) {
                        toast.error("Unexpected error format");
                    }
                });
            } else {
                // Fallback normal JSON case
                if (error.response?.data?.status_code === "ERR66" && error.response?.data?.http_status === 500) {
                    toast.error(error.response.data.message);
                } else {
                    toast.error("Something went wrong");
                }
            }

            setIsDownloading(false);
            return Promise.resolve();
            //return Promise.reject('Error generating PDF');
        }
    };

    const groupedCourses = studentData.reduce((acc, item) => {
        const key = item.course_code; // safest unique key

        if (!acc[key]) {
            acc[key] = {
                course_name: item.course_name,
                course_code: item.course_code,
                coursetype: item.coursetype,
                fees: []
            };
        }

        acc[key].fees.push({
            feedesc: item.feedesc,
            paperamt: item.paperamt
        });

        return acc;
    }, {});

    const courseList = Object.values(groupedCourses);

    const { paperTotal, grandTotal } = useMemo(() => {

        const pTotal = studentData?.reduce((acc, curr) => acc + (curr.paperamt || 0), 0) || 0;
        const sTotal = StudentFee || 0;
        return {
            paperTotal: pTotal,

            grandTotal: pTotal + sTotal
        };
    }, [studentData, StudentFee]);



    return (
        <>
            <StudentTemplate>
                <ToastContainer />
                {isDownloading ? (
                    <Loader />
                ) : (
                    <div className="container ">
                        <div className="row justify-content-center">
                            <div className="col-12 col-xl-12">
                                <div className="card shadow-sm border-0 rounded-4 overflow-hidden">
                                    <div className="card-body p-3 p-md-5">
                                        {/* Header Section */}
                                        <header className="text-center mb-4">
                                            <h2 className="h4 fw-bold text-dark mb-2">Exam Registration</h2>
                                            <p className="text-muted small">Select your exam and verify details before downloading the form.</p>
                                        </header>

                                        {/* Dropdown Section */}
                                        <div className="mb-4">
                                            <label className="form-label small fw-semibold text-uppercase text-muted">Select Examination</label>
                                            <Select
                                                maxMenuHeight={250}
                                                menuPlacement="auto"
                                                id="exam_id"
                                                name="exam_id"
                                                className="basic-select shadow-sm"
                                                classNamePrefix="select"
                                                options={getexamData.map(exam => ({
                                                    value: exam.examid,
                                                    label: exam.examtitle,
                                                    semesterid: exam.semesterid
                                                }))}
                                                onChange={handlExamChange}
                                                placeholder="Search for exam..."
                                            />
                                        </div>

                                        {examid && (
                                            <div className="animate__animated animate__fadeIn">
                                                <div className="row g-4">

                                                    {/* LEFT: Registration Type & Course List */}
                                                    <div className="col-12 col-lg-7 order-2 order-lg-1">


                                                        {/* Course List Section */}
                                                        <section>
                                                            <h6 className="fw-bold mb-3 d-flex align-items-center">
                                                                <i className="bi bi-journal-text me-2 text-primary"></i> Selected Courses
                                                            </h6>
                                                            {studentData?.length > 0 ? (
                                                                <div className="vstack gap-3">
                                                                    {courseList.map((course, index) => (
                                                                        <div key={index} className="card border-0 bg-light rounded-3 p-3">
                                                                            <div className="d-flex justify-content-between align-items-start mb-2">
                                                                                <div className="flex-grow-1 pe-2 d-flex flex-column gap-3 ">
                                                                                    <h6 className="fw-bold text-dark mb-1 small-mobile-text">
                                                                                        {course.course_name} ({course.coursetype})
                                                                                    </h6>

                                                                                    <span className="badge bg-white text-muted border align-self-start">
                                                                                        {course.course_code}
                                                                                    </span>
                                                                                </div>
                                                                                <div className="text-primary fw-bold">₹{course.fees?.reduce((acc, curr) => acc + (curr.paperamt || 0), 0) || 0}</div>

                                                                            </div>
                                                                            {course.fees?.map((fee, i) => (
                                                                                <div key={i} className="d-flex justify-content-between small text-muted border-top pt-1 mt-1">
                                                                                    <span>{fee.feedesc || "Exam Fee"}</span>
                                                                                    <span>₹{fee.paperamt}</span>
                                                                                </div>
                                                                            ))}
                                                                        </div>
                                                                    ))}
                                                                </div>
                                                            ) : (
                                                                <div className="alert alert-light border border-dashed text-center">No courses found.</div>
                                                            )}
                                                        </section>
                                                    </div>

                                                    {/* RIGHT:  */}
                                                    <div className="col-12 col-lg-5 order-1 order-lg-2">


                                                        <section className="mb-4">
                                                            <h6 className="fw-bold mb-3 d-flex align-items-center">
                                                                <i className="bi bi-person-badge me-2 text-primary"></i> Registration Type
                                                            </h6>
                                                            <div className="vstack gap-2">
                                                                {[
                                                                    { id: "R", label: "Regular", sub: "Normal Exam", kp: 0 },
                                                                    // { id: "SL", label: "Slow Learner", sub: "Extended Exam", kp: 0 },
                                                                    { id: "KPCR", label: "KPCR", sub: "Private Candidate", kp: 1 }

                                                                ].map((type) => (
                                                                    <label key={type.id}
                                                                        className={`p-3 rounded-3 border d-flex align-items-center justify-content-between transition-all ${(type.id === "KPCR" ? Kpcr === 1 : (Regtype === type.id && Kpcr === 0))
                                                                            ? "border-primary bg-primary-subtle shadow-sm"
                                                                            : "bg-white border-light-subtle"
                                                                            }`}
                                                                        style={{ cursor: 'pointer' }}
                                                                    >
                                                                        <div className="me-3">
                                                                            <div className="fw-bold text-dark">{type.label}</div>
                                                                            <div className="small text-muted">{type.sub}</div>
                                                                        </div>
                                                                        <input
                                                                            type="radio"
                                                                            className="form-check-input"
                                                                            name="examType"
                                                                            checked={type.id === "KPCR" ? Kpcr === 1 : (Regtype === type.id && Kpcr === 0)}
                                                                            onChange={() => {
                                                                                if (type.id === "KPCR") { setKpcr(1); setRegtypeData(""); }
                                                                                else { setRegtypeData(type.id); setKpcr(0); }
                                                                            }}
                                                                        />
                                                                    </label>
                                                                ))}
                                                            </div>
                                                        </section>

                                                        <div className="card bg-dark text-white border-0 rounded-4 sticky-top shadow-lg" style={{ top: '1rem', zIndex: 10 }}>
                                                            <div className="card-body p-4">
                                                                <h6 className="fw-bold mb-4 opacity-75 text-uppercase letter-spacing-1">Payment Summary</h6>



                                                                <div className="d-flex justify-content-between mb-3">
                                                                    <span className="opacity-75">Total Papers ({courseList.length})</span>
                                                                    <span className="fw-semibold">₹{paperTotal}</span>
                                                                </div>



                                                                <div className="d-flex justify-content-between mb-4">
                                                                    <span className="opacity-75">Semester Fee</span>
                                                                    <span className="fw-semibold">₹{StudentFee}</span>
                                                                </div>

                                                                <div className="border-top border-secondary pt-3 mt-3">
                                                                    <div className="d-flex justify-content-between align-items-center mb-4">
                                                                        <span className="h6 mb-0">Grand Total</span>
                                                                        <span className="h3 mb-0 fw-bold text-primary">₹{grandTotal}</span>
                                                                    </div>

                                                                    <button
                                                                        onClick={handleGeneratePDFNew}
                                                                        disabled={isDownloading || !studentData?.length}
                                                                        className="btn btn-primary btn-lg w-100 py-3 rounded-3 shadow d-flex align-items-center justify-content-center gap-2"
                                                                    >
                                                                        {isDownloading ? (
                                                                            <><span className="spinner-border spinner-border-sm"></span> Generating...</>
                                                                        ) : (
                                                                            <><i className="bi bi-cloud-arrow-down-fill"></i> Download Form</>
                                                                        )}
                                                                    </button>
                                                                    <p className="text-center small opacity-50 mt-3 mb-0"></p>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>

                                                </div>
                                            </div>
                                        )}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                )}
            </StudentTemplate>
        </>
    );
};

export default ExamReg;